// extracted by mini-css-extract-plugin
export default {"root":"view-switch_root__xHxIE","button":"view-switch_button__KOvuv","active":"view-switch_active__tvLq5","icon":"view-switch_icon__OsVRd"};